import { styled } from '@mui/material/styles';

export const HighlightedPolygonBox = styled('div')(() => ({
  position: 'absolute',
  border: '1px solid rgb(221, 129, 0)',
  boxSizing: 'content-box',
  pointerEvents: 'none',
  opacity: 1,
  background: 'rgba(225, 225, 0, 0.15)',
}));
